<template>
  <div style="padding-bottom: 0.625rem">
    <el-card>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#FAFAFA',
          color: '#000',
          'text-align': 'center',
        }"
      >
        <el-table-column label="排名" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="姓名" align="center">
        </el-table-column>
        <el-table-column prop="Time" label="学习时长（分钟）" align="center">
        </el-table-column>
        <el-table-column
          prop="CurriculumCount"
          label="完成课程（个）"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="OverCount" label="获得证书（个）" align="center">
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center">
          <template slot-scope="scope">
            <div class="tui-lookDetail" @click="onClickLookDetail(scope.row)">
              查看详情
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { GetTeacherVideoStatisticsInfo } from "../../../api/api";

export default {
  data() {
    return {
      tableData: [],
    };
  },
  created() {
    this.GetTeacherVideoStatisticsInfo();
  },
  methods: {
    async GetTeacherVideoStatisticsInfo() {
      let res = await GetTeacherVideoStatisticsInfo();
      if (res.data.success) {
        this.tableData = res.data.response;
      } else {
        this.tableData = [];
      }
    },
    onClickLookDetail(item) {
      this.$router.push({
        path: "/Teacher-Tain/Rector/detail",
        query: {
          obj: JSON.stringify(item),
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-divider--vertical {
  height: 0.725rem;
  background: #ccc;
}
.tui-lookDetail {
  color: #1890ff;
  font-size: 0.2rem;
  cursor: pointer;
}
.tui-record {
  color: #333333;
  font-size: 0.3rem;
  font-weight: 600;
  padding: 0.25rem 0;
}
.tui-raius {
  border-radius: 0.15rem;
  .tui-box {
    .tui-column {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      .title {
        color: #333;
        font-size: 0.25rem;
        padding-left: 0.125rem;
      }
      .time {
        color: #1890ff;
        font-size: 0.475rem;
      }
      .hour {
        color: #1890ff;
        font-size: 0.1875rem;
        padding-left: 0.0625rem;
      }
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
    }
    .title {
      color: #333333;
      font-size: 0.25rem;
      font-weight: 600;
      padding-left: 0.125rem;
    }
    img {
      width: 0.45rem;
      height: 0.45rem;
    }
  }
}
</style>